const reviews = [
    {
        id: 301,
        userName: '장*호',
        reviewImg: process.env.PUBLIC_URL + '/images/PorkCutletDonburi.png',
        reviewTxt: '맛도 좋고 구성도 알차서 만족했습니다! 반찬 하나하나 간이 잘 맞고 깔끔해서 자주 주문하고 싶어요 😊 다음에도 또 이용할게요!',
        productName: '돈까스새우 돈부리 컵밥',
        day: '2026. 01. 29'
    },
    {
        id: 302,
        userName: '양*웅',
        reviewImg: process.env.PUBLIC_URL + '/images/HeartyBulgogiBox.png',
        reviewTxt: '맛은 물론이고 전체적인 구성이 정말 알찼어요. 자극적이지 않으면서도 간이 딱 좋아서 부담 없이 먹기 좋았습니다. 재주문 의사 있어요!',
        productName: '알찬불백 도시락',
        day: '2026. 01. 25'
    },
    {
        id: 303,
        userName: '박*원',
        reviewImg: process.env.PUBLIC_URL + '/images/PorkCutletBox.png',
        reviewTxt: '음식이 전반적으로 깔끔하고 정성이 느껴졌어요. 반찬마다 맛의 밸런스가 좋아서 끝까지 맛있게 먹었습니다. 다음에 또 주문할게요 😊',
        productName: '등심 돈까스 도시락',
        day: '2026. 01. 24'
    },
    {
        id: 304,
        userName: '이*범',
        reviewImg: process.env.PUBLIC_URL + '/images/SpamKimchiFriedRice.png',
        reviewTxt: '양도 적당하고 맛도 기대 이상이었어요. 하나하나 신경 쓴 게 느껴져서 만족스러웠습니다. 자주 이용하게 될 것 같아요!',
        productName: '스팸 김치볶음밥',
        day: '2026. 01. 25'
    },
    {
        id: 305,
        userName: '박*언',
        reviewImg: process.env.PUBLIC_URL + '/images/ChickenBulgogiBox.png',
        reviewTxt: '음식이 전체적으로 정말 정갈하고 간이 딱 좋아요. 과하지도 부족하지도 않아서 먹는 내내 편해 만족스러운 식사였습니다.',
        productName: '치킨불백 도시락',
        day: '2026. 01. 21'
    },
    {
        id: 306,
        userName: '위*우',
        reviewImg: process.env.PUBLIC_URL + '/images/SoySaucePorkBox.png',
        reviewTxt: '자극적이지 않으면서도 맛의 밸런스가 좋아서 부담 없이 즐기기 좋았어요. 처음부터 끝까지 질리지 않고 맛있게 잘 먹었습니다',
        productName: '간장제육 도시락',
        day: '2026. 01. 20'
    },
    {
        id: 307,
        userName: '배*한',
        reviewImg: process.env.PUBLIC_URL + '/images/ChefSpecialBox.png',
        reviewTxt: '반찬 구성도 알차고 각각의 맛이 고르게 잘 어우러져요. 집밥처럼 편안한 느낌이라 먹고 나서도 계속 생각날 것 같아요.',
        productName: '별미한상 도시락',
        day: '2026. 01. 10'
    },
    {
        id: 308,
        userName: '도*',
        reviewImg: process.env.PUBLIC_URL + '/images/AgedKimchiStew.png',
        reviewTxt: '전체적으로 깔끔한 맛이라 호불호 없이 누구나 좋아할 스타일입니다. 퀄리티가 좋아서 다음에도 꼭 다시 주문할게요. 재주문 의사 100% 👍',
        productName: '묵은지김치찌개 세트',
        day: '2026. 01. 04'
    },
]

export default reviews;